export default {"src":"/_next/static/image/src/assets/footer/tiktok.825a818b6e76574293ee30cc86994938.svg","height":24,"width":24};